<template>
    <span :class="{ 'truncate': truncate }">
        <template v-if="column === 'number'">
            {{ rowNumber }}
        </template>
        <template v-if="column === 'name'">
            <nio-optional :value="contactName" />
        </template>
        <template v-if="column === 'phone'">
            <nio-optional :value="contactPhone" />
        </template>
        <template v-if="column === 'date'">
            <nio-optional :value="appointmentDate" />
        </template>
        <template v-if="column === 'status'">
            <template v-if="appointment.import_error">
                <span class="flex items-center" v-tooltip="$t('imports.preview.missingRequiredDate')">
                    <nio-icon class="mr-2 text-lg text-red-500" name="bold/remove-circle" />
                    {{ $t('global.general.error') }}
                </span>
            </template>
            <template v-else-if="contactName">
                <span class="flex items-center">
                    <nio-icon class="mr-2 text-lg text-green-500" name="bold/check-circle-1" />
                    {{ $t('global.general.success') }}
                </span>
            </template>
            <template v-else>
                <span class="flex items-center" v-tooltip="$t('imports.preview.missingOptionalData')">
                    <nio-icon class="mr-2 text-lg text-yellow-500" name="bold/alert-triangle" />
                    {{ $t('global.general.warning') }}
                </span>
            </template>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            column: {
                type: String,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            appointment: {
                type: Object,
                required: true,
            },
            truncate: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            rowNumber() {
                return this.index + 1;
            },

            contactName() {
                return this.formatFullName(this.appointment.contact);
            },

            contactPhone() {
                if (!this.appointment.contactPhone) {
                    return '';
                }

                return this.formatPhone(this.appointment.contactPhone.number);
            },

            appointmentDate() {
                return this.formatDateTime(this.appointment.datetime);
            },
        },
    };
</script>
